import React, {useContext} from 'react';
import type {ConnectElementImportKeys} from '../../connect/ConnectJSInterface/ConnectElementList';
import {CONNECT_ELEMENT_IMPORTS} from '../../connect/ConnectJSInterface/ConnectElementList';
import type {
  ConnectElementSupplementalFunctions,
  IConnectElementSupplementalFunction,
} from '../../connect/ConnectElementSupplementalFunctions';

export const SupplementalFunctionContext = React.createContext<
  Partial<IConnectElementSupplementalFunction>
>({});
SupplementalFunctionContext.displayName = 'SupplementalFunctionContext';

export type Props = {
  supplementalFunctions: ConnectElementSupplementalFunctions;
  component: ConnectElementImportKeys;
};

export const SupplementalFunctionProvider: React.FC<Props> = ({
  children,
  supplementalFunctions,
  component,
}) => {
  const componentConfig = CONNECT_ELEMENT_IMPORTS[component];

  const [currentSupplementalFunction, setSupplementalFunction] = React.useState<
    Partial<IConnectElementSupplementalFunction>
  >(supplementalFunctions.values);

  React.useEffect(() => {
    const observer = () => {
      setSupplementalFunction(supplementalFunctions.values);
    };
    supplementalFunctions.registerObserver(observer);
    return () => {
      supplementalFunctions.unregisterObserver(observer);
    };
  }, [supplementalFunctions, componentConfig]);

  return (
    <SupplementalFunctionContext.Provider value={currentSupplementalFunction}>
      {children}
    </SupplementalFunctionContext.Provider>
  );
};

export const useSupplementalFunction = () =>
  useContext(SupplementalFunctionContext);
